/**
 * Transforms a single question item to the GraphQL node format
 */
export function mapQuestionToNode(item) {
    return {
        id: item.id,
        data: {
            ...item.data,
            isSubQuestion: item.data.isSubQuestion ?? false,
        },
        type: item.type,
        ctime: item.ctime,
        utime: item.utime,
        sequence: item.sequence ?? 0,
        attributes: {
            answered: item.attributes?.answered ?? false,
        },
    };
}
/**
 * Transforms a paginated list of questions to the GraphQL format
 */
export function mapPaginatedQuestions(result) {
    return {
        totalCount: result?.totalCount ?? 0,
        list: result?.list.map(mapQuestionToNode) ?? [],
    };
}
